import { combineReducers } from "redux";
import userAuthReducer from "./userAuthReducer";
import promoteursReducer from "./promoteursReducer";
import immobilierReducer from "./immobilierReducer";
import displayHonorairesReducer from "./honorairesReducer";
import modalReducer from "./modalReducer";
import enregistresReducer from "./enregistresReducer";
import userListReducer from "./userListReducer";
import agenciesReducer from "./agneciesReducer";
import citiesReducer from "./citiesReducer";
import deepsearchReducer from "./deepsearchReducer";
import discussionsReducer from "./discussionsReducer";

const rootReducer = combineReducers({
  userAuthReducer,
  promoteursReducer,
  immobilierReducer,
  displayHonorairesReducer,
  modalReducer,
  enregistresReducer,
  userListReducer,
  discussionsReducer,
  agenciesReducer,
  citiesReducer,
  deepsearchReducer,
});

export default rootReducer;
